import _styled from "styled-components";
const _excluded = ["index"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/web.dom-collections.iterator.js";
import { observer } from "mobx-react";
import Mustache from "mustache";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useVirtual } from "react-virtual";
import styled from "styled-components";
import Box from "../../../Styled/Box";
import Button from "../../../Styled/Button";
import parseCustomMarkdownToReact from "../../Custom/parseCustomMarkdownToReact";
import MapEffects from "./MapEffects";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SearchResults = props => {
  const {
    item,
    results
  } = props;
  const [currentMapEffect, setCurrentMapEffect] = useState({
    is: "highlightAll"
  });
  const selectedResult = currentMapEffect.is === "highlightSingleResult" ? currentMapEffect.result : undefined;
  const parentRef = useRef(null);
  const list = useVirtual({
    size: results.length,
    parentRef,
    estimateSize: useCallback(() => 50, [])
  });
  const [t] = useTranslation();
  const toggleSelection = newSelection => {
    if (currentMapEffect.is === newSelection.is && currentMapEffect.result === newSelection.result) {
      setCurrentMapEffect({
        is: "none"
      });
    } else {
      setCurrentMapEffect(newSelection);
    }
  };
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(ResultsCount, {
      count: results.length
    }), /*#__PURE__*/_jsxs(ActionMenu, {
      children: [/*#__PURE__*/_jsx(ActionButton, {
        selected: currentMapEffect.is === "highlightAll",
        onClick: () => toggleSelection({
          is: "highlightAll"
        }),
        children: t("itemSearchTool.actions.highlightAll")
      }), /*#__PURE__*/_jsx(ActionButton, {
        selected: currentMapEffect.is === "showMatchingOnly",
        onClick: () => toggleSelection({
          is: "showMatchingOnly"
        }),
        children: t("itemSearchTool.actions.showMatchingOnly")
      })]
    }), /*#__PURE__*/_jsx(List, {
      ref: parentRef,
      height: "250px",
      children: /*#__PURE__*/_jsx(ListInner, {
        height: "".concat(list.totalSize, "px"),
        children: list.virtualItems.map(_ref => {
          let {
              index
            } = _ref,
            row = _objectWithoutProperties(_ref, _excluded);
          return /*#__PURE__*/_jsx(Result, {
            result: results[index],
            isSelected: results[index].id === (selectedResult === null || selectedResult === void 0 ? void 0 : selectedResult.id),
            isEven: index % 2 === 0,
            onClick: () => toggleSelection({
              is: "highlightSingleResult",
              result: results[index]
            }),
            template: props.template,
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "".concat(row.size, "px"),
              transform: "translateY(".concat(row.start, "px)")
            }
          }, results[index].id);
        })
      })
    }), /*#__PURE__*/_jsx(MapEffects, {
      effect: currentMapEffect,
      item: item,
      results: results
    })]
  });
};
export const Result = observer(props => {
  const {
    result,
    template,
    isEven,
    isSelected,
    style
  } = props;
  const content = template ? parseCustomMarkdownToReact(Mustache.render(template, result.properties)) : result.id;
  const onClick = e => {
    try {
      props.onClick(result);
    } finally {
      e.preventDefault();
    }
  };
  return /*#__PURE__*/_jsx(ClickableItem, {
    role: "button",
    isEven: isEven,
    isSelected: isSelected,
    onClick: onClick,
    style: style,
    children: content
  });
});
const ClickableItem = styled.a.withConfig({
  displayName: "SearchResults__ClickableItem",
  componentId: "sc-mpaxje-0"
})(["display:block;box-sizing:border-box;padding:5px 10px;cursor:pointer;", ""], p => "background-color: ".concat(p.isSelected ? p.theme.toolPrimaryColor : p.isEven ? p.theme.dark : p.theme.darkLighter, ";"));
const List = styled.div.withConfig({
  displayName: "SearchResults__List",
  componentId: "sc-mpaxje-1"
})(["", ";width:100%;overflow:auto;"], p => "height: ".concat(p.height));
const ListInner = styled.div.withConfig({
  displayName: "SearchResults__ListInner",
  componentId: "sc-mpaxje-2"
})(["", ";width:100%;position:relative;"], p => "height: ".concat(p.height));
const Wrapper = styled(Box).attrs({
  column: true,
  flex: 1
}).withConfig({
  displayName: "SearchResults__Wrapper",
  componentId: "sc-mpaxje-3"
})([">:only-child{flex:1;align-self:center;align-items:center;}"]);
export const ResultsCount = _ref2 => {
  let {
    count
  } = _ref2;
  const [t] = useTranslation();
  return /*#__PURE__*/_jsx(_StyledBox, {
    $_css: count === 0 ? "align-self: center;" : "",
    children: t("itemSearchTool.resultsCount", {
      count
    })
  });
};
const ActionButton = styled(Button).attrs(props => ({
  primary: props.selected,
  secondary: !props.selected,
  textProps: {
    medium: true
  }
})).withConfig({
  displayName: "SearchResults__ActionButton",
  componentId: "sc-mpaxje-4"
})(["min-height:20px;padding:1em;padding-top:2px;padding-bottom:2px;border:0px;border-radius:5px;"]);
const ActionMenu = styled.div.withConfig({
  displayName: "SearchResults__ActionMenu",
  componentId: "sc-mpaxje-5"
})(["display:flex;justify-content:flex-end;padding:0.5em;background-color:", ";border-top-left-radius:5px;border-top-right-radius:5px;> ", ":first-child{margin-right:1em;}"], p => p.theme.charcoalGrey, ActionButton);
export default SearchResults;
var _StyledBox = styled(Box).withConfig({
  displayName: "SearchResults___StyledBox",
  componentId: "sc-mpaxje-6"
})(["margin-bottom:1em;", ""], p => p.$_css);